import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { FieldValues, Control } from 'react-hook-form';
import { Input } from '@/components/ui/input';

interface InputFieldProps {
  control: unknown;
  name: string;
  label?: string;
  placeholder: string;
  type?: string;
  disabled?: boolean;
  maxLength?: number;
  minLength?: number;
  onInput?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isMandatory?: boolean;
  hideLabel?: boolean;
}

export const InputField = ({
  control,
  name,
  label,
  placeholder,
  type = 'text',
  disabled = false,
  maxLength,
  minLength,
  onInput,
  isMandatory,
  hideLabel,
}: InputFieldProps) => {
  return (
    <FormField
      control={control as Control<FieldValues>}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem>
          {label && (
            <FormLabel className={hideLabel ? 'invisible' : ''}>
              {label}
              {isMandatory && (
                <span
                  className={
                    fieldState.error?.message ? 'text-red-500' : 'text-inherit'
                  }
                >
                  *
                </span>
              )}
            </FormLabel>
          )}
          <FormControl className="focus-within:outline-none focus-within:ring-2">
            <Input
              className={`focus:outline-none focus:ring-0 ${
                !!fieldState.error?.message && 'border-red-500'
              }`}
              type={type}
              maxLength={maxLength}
              minLength={minLength}
              placeholder={placeholder}
              {...field}
              onInput={onInput}
              disabled={disabled}
              onChange={(e) =>
                type === 'number'
                  ? field.onChange(e.target.valueAsNumber)
                  : field.onChange(e.target.value)
              }
            />
          </FormControl>
          <FormMessage className="opacity-70">
            {fieldState.error?.message}
          </FormMessage>
        </FormItem>
      )}
    />
  );
};
